// Static route options - these will be translated in the component
export const medicationRoutes = [
  'Oral',
  'Intravenous',
  'Topical',
  'Subcutaneous',
  'Intramuscular',
  'Inhaled',
  'Rectal',
  'Vaginal',
  'Ophthalmic',
  'Otic',
  'Nasal',
  'Transdermal',
];

// Static frequency options - these will be translated in the component
export const medicationFrequencies = [
  'Once daily (QD)',
  'Twice daily (BID)',
  'Three times daily (TID)',
  'Four times daily (QID)',
  'Every morning (QAM)',
  'Every evening (QPM)',
  'Every 4 hours (Q4H)',
  'Every 6 hours (Q6H)',
  'Every 8 hours (Q8H)',
  'Every 12 hours (Q12H)',
  'At bedtime (HS)',
  'Other', // Added Other
];

// Helper function to get translated route options
export const getTranslatedRoutes = (t) => [
  { value: 'Oral', label: t('medications.routes.oral') },
  { value: 'Intravenous', label: t('medications.routes.intravenous') },
  { value: 'Topical', label: t('medications.routes.topical') },
  { value: 'Subcutaneous', label: t('medications.routes.subcutaneous') },
  { value: 'Intramuscular', label: t('medications.routes.intramuscular') },
  { value: 'Inhaled', label: t('medications.routes.inhaled') },
  { value: 'Rectal', label: t('medications.routes.rectal') },
  { value: 'Vaginal', label: t('medications.routes.vaginal') },
  { value: 'Ophthalmic', label: t('medications.routes.ophthalmic') },
  { value: 'Otic', label: t('medications.routes.otic') },
  { value: 'Nasal', label: t('medications.routes.nasal') },
  { value: 'Transdermal', label: t('medications.routes.transdermal') },
];

// Helper function to get translated frequency options
export const getTranslatedFrequencies = (t) => [
  { value: 'Once daily (QD)', label: t('medications.frequencies.onceDailyQD') },
  { value: 'Twice daily (BID)', label: t('medications.frequencies.twiceDailyBID') },
  { value: 'Three times daily (TID)', label: t('medications.frequencies.threeDailyTID') },
  { value: 'Four times daily (QID)', label: t('medications.frequencies.fourDailyQID') },
  { value: 'Every morning (QAM)', label: t('medications.frequencies.everyMorningQAM') },
  { value: 'Every evening (QPM)', label: t('medications.frequencies.everyEveningQPM') },
  { value: 'Every 4 hours (Q4H)', label: t('medications.frequencies.every4HoursQ4H') },
  { value: 'Every 6 hours (Q6H)', label: t('medications.frequencies.every6HoursQ6H') },
  { value: 'Every 8 hours (Q8H)', label: t('medications.frequencies.every8HoursQ8H') },
  { value: 'Every 12 hours (Q12H)', label: t('medications.frequencies.every12HoursQ12H') },
  { value: 'At bedtime (HS)', label: t('medications.frequencies.atBedtimeHS') },
  { value: 'Other', label: t('medications.frequencies.other') },
];
